import React from 'react';

const About = () => {
  return (
    <main className="min-h-screen bg-white p-6">
      <section className="max-w-6xl mx-auto py-12">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl font-extrabold text-indigo-800 mb-6">Who We Are</h1>
            <p className="text-lg text-gray-700 mb-4">
              EmpowerHer and Girls-To-Tech are sister initiatives driving digital equity for African women and girls. From foundational digital literacy to specialized tech career tracks, we provide a clear, guided pathway for growth.
            </p>
            <p className="text-lg text-gray-700">
              Whether you're touching a computer for the first time or looking to launch a career in Cloud Computing or Data Science, our programs are built to meet you where you are.
            </p>
          </div>
          <div>
            <img 
              src="/images/women-in-tech.png" 
              alt="Women learning on laptops" 
              className="rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      <section className="bg-indigo-50 py-12 mt-8">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-indigo-800 mb-6">Our Approach</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">Accessible Learning</h3>
              <p className="text-gray-700">Digital skills for all—no experience required, with both online and offline access.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">Personalized Pathways</h3>
              <p className="text-gray-700">Tailored tech journeys driven by your interests and goals using AI-guided tools.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">Mentorship</h3>
              <p className="text-gray-700">Direct access to industry professionals to guide, encourage, and connect you.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="text-xl font-semibold text-indigo-700 mb-2">Recognition</h3>
              <p className="text-gray-700">Earn certificates and get noticed—every step forward is a credential earned.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-indigo-800 mb-4">From Kenya to Africa</h2>
        <p className="text-lg text-gray-700">
          We launched in Kenya, but our eyes are set on the entire continent. By scaling impact locally and expanding regionally, we envision a future where digital inclusion becomes the norm—not the exception.
        </p>
      </section>
    </main>
  );
};

export default About;
